// SPDX-License-Identifier: AGPL-3.0-or-later

import {CopyIdIcon} from '@app/features/ui/action_menu/ContextMenuIcons';
import {MenuGroup} from '@app/features/ui/action_menu/MenuGroup';
import {MenuItem} from '@app/features/ui/action_menu/MenuItem';
import * as TextCopyCommands from '@app/features/ui/commands/TextCopyCommands';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useCallback} from 'react';

interface WebhookContextMenuProps {
	webhookId: string;
	onClose: () => void;
}
export const WebhookContextMenu: React.FC<WebhookContextMenuProps> = observer(({webhookId, onClose}) => {
	const {i18n, t} = useLingui();
	const handleCopyWebhookId = useCallback(() => {
		TextCopyCommands.copy(i18n, webhookId, true);
		onClose();
	}, [i18n, webhookId, onClose]);
	return (
		<MenuGroup>
			<MenuItem icon={<CopyIdIcon />} onClick={handleCopyWebhookId}>
				{t`Copy webhook ID`}
			</MenuItem>
		</MenuGroup>
	);
});
